import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { CompetitorComparison } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface CompetitorComarisionsProps {
    data?: CompetitorComparison[];
    style?: CSSProperties;
}

export const CompetitorComarisions: FC<CompetitorComarisionsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                Direct competitor pricing and service comparisons
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column title="Competitors" dataIndex="competitor" width={334} />
                <Column title="Pricing comparison" dataIndex="pricing" width={334} />
                <Column title="Feature/Service Differences" dataIndex="differences" width={334} />
                <Column title="Pros and Cons" dataIndex="prosAndCons" />
            </Table>
        </div>
    );
};
